import React from "react";
import classes from "./ContactUs.module.css";
import { useSelector } from "react-redux";
function ContactUs() {
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  return (
    <div className={classes.helperDetails}>
      <h4 className={classes.h4}>Contact Us</h4>
      <div className="d-flex">
        <div
          className={`d-flex align-items-center justify-content-evenly flex-column ${classes.width}  ${classes.gap} ${classes.findUs} helpdropDown`}
        >
          <div>
            <h6 className={classes.h6}>
              {(selectedRole === "L" || selectedRole === "V") &&
                "Lender Hotline"}
            </h6>
            <p>
              {(selectedRole === "L" || selectedRole === "V") &&
                "818-797-5838 (10am - 4pm)"}
            </p>
          </div>

          {(selectedRole === "L" || selectedRole === "B") && (
            <div>
              <h6 className={classes.h6}>General Customer Service</h6>
              <p>(818) 483 - 0027 (7am - 5pm)</p>
            </div>
          )}

          <div>
            <h6 className={classes.h6}>FAX US</h6>
            <p>(818) 876-0337</p>
          </div>
          <div>
            <h6 className={classes.h6}>LOCATION</h6>
            <p>
              28348 Roadside Dr. 1st floor
              <br />
              Agoura Hills, CA 91301
            </p>
          </div>
          {/* <div>
            <h6 className={classes.h6}>MAIL US</h6>

            <p>info@superiorloanservicing.com</p>
          </div> */}
        </div>
        <iframe
          className={classes.width}
          // src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3299.620757017645!2d-118.606034!3d34.207165!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c29c43d3902d0d%3A0x94fab6bfd5d8f128!2s7525%20Topanga%20Canyon%20Blvd%2C%20Canoga%20Park%2C%20CA%2091303!5e0!3m2!1sen!2sus!4v1679125027475!5m2!1sen!2sus"
          src="https://www.google.com/maps?q=28348+Roadside+Dr+1st+floor+Agoura+Hills+CA+91301&output=embed"
          width="100%"
          height="450"
          style={{
            border: "1px solid #ff8157ed",
            borderRadius: "0px 5px 5px 0px",
          }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactUs;
